import "./background.scss";
import * as utils from "shell/app/app.utils";
import { useLayoutEffect, useRef } from "react";

interface bgProps {}

const Background: React.FC<bgProps> = (props) => {
  const bgRef = useRef<HTMLDivElement>(null);
  const galaxyRef = useRef<HTMLImageElement>(null);
  const aFrame = useRef<any>(0);

  useLayoutEffect(() => {
    const render = () => {
      const bg = bgRef.current;
      const galaxy = galaxyRef.current;
      if (bg) {
        bg.style.setProperty(
          "transform",
          `translateY(${-window.rcScrollY/2}px)`
        );
      }
      if (galaxy) {
        galaxy.style.setProperty(
          "transform",
          `translateY(${-window.rcScrollY/2}px)`
        );
      }
      aFrame.current = requestAnimationFrame(render);
    };
    //
    aFrame.current = requestAnimationFrame(render);
    return () => cancelAnimationFrame(aFrame.current);
  }, []);

  return (
    <div className="background">
      <div
        className="background__bg"
        style={{
          backgroundImage: `url(${utils.assetPath("/images/background.jpg")})`,
        }}
        ref={bgRef}
      />
      {/* <img src={utils.assetPath("/images/galaxy.jpg")} className="background__galaxy" ref={galaxyRef} /> */}
    </div>
  );
};

export default Background;
